// extracted by mini-css-extract-plugin
module.exports = {"c1sn74qb":"c1sn74qb","p1kg5er3":"p1kg5er3"};